/** @format */

import moment from "moment";
import { useMemo } from "react";
import { findValuesFromArray } from "utils/helper";

export const useJadwalPengajuanBos = (
  bos,
  activeTabKey,
  role,
  tmpSumberDana,
) => {
  const tmpJadwalPengajuan = useMemo(() => {
    return bos?.jadwalPengajuanBos || [];
  }, [bos?.jadwalPengajuanBos]);

  // Diurutkan DESC by start_date sebelum find() supaya dapat batch/jadwal
  // pengajuan TERBARU untuk sumberdana aktif, bukan yang pertama muncul di
  // response API (yang bisa jadi batch tertua) — pola sama dengan getJadwal
  // di Rencana/PaguDef/Pendapatan/Component/ModalDokumenBos.tsx.
  const jadwalList = useMemo(() => {
    return (
      [...tmpJadwalPengajuan]
        .sort(
          (a: any, b: any) =>
            new Date(b.start_date).getTime() - new Date(a.start_date).getTime(),
        )
        .find((item: any) => item.sumberdana === activeTabKey) || null
    );
  }, [tmpJadwalPengajuan, activeTabKey]);

  const activeJadwal = useMemo(() => {
    const now = moment();
    return (
      tmpJadwalPengajuan.find(
        (item: any) =>
          item.sumberdana === activeTabKey &&
          now.isAfter(item.start_date) &&
          now.isBefore(moment(item.end_date_verifikator)),
      ) || null
    );
  }, [tmpJadwalPengajuan, activeTabKey]);
  const messageInformation = useMemo(() => {
    if (role === "verifikator") {
      if (!activeJadwal) {
        const lastJadwal: any =
          [...tmpJadwalPengajuan]
            .reverse()
            .find((item) => moment().isAfter(item.end_date_verifikator)) ||
          null;

        return (
          <div className="text-red-500 font-bold">
            Batas Verifikasi Pengajuan{" "}
            {findValuesFromArray(
              tmpSumberDana,
              "kode",
              lastJadwal?.sumberdana,
              "nama",
            )}{" "}
            berakhir pada{" "}
            {moment(lastJadwal?.end_date_verifikator).format("DD MMMM YYYY")}{" "}
            pukul {moment(lastJadwal?.end_date_verifikator).format("HH:mm")} WIB
          </div>
        );
      } else {
        return (
          <div className="text-green-500 font-bold">
            Verifikasi Pengajuan{" "}
            {findValuesFromArray(
              tmpSumberDana,
              "kode",
              activeJadwal?.sumberdana,
              "nama",
            )}{" "}
            sedang berjalan di mulai dari{" "}
            {moment(activeJadwal?.start_date).format("DD MMMM YYYY")} sampai
            dengan{" "}
            {moment(activeJadwal?.end_date_verifikator).format("DD MMMM YYYY")}{" "}
            pukul {moment(activeJadwal?.end_date_verifikator).format("HH:mm")}{" "}
            WIB
          </div>
        );
      }
    } else {
      return `textInformation`;
    }
  }, [activeJadwal, role, tmpSumberDana, tmpJadwalPengajuan]);

  return {
    jadwalList,
    activeJadwal,
    messageInformation,
  };
};
